import { formatterTime } from "@/util/util";
export default (serviceHotlineOption) => {
  console.log(serviceHotlineOption); //vue的this对象
  return {
    index: true,
    align: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    menu: true,
    page: true,
    column: [
      {
        label: "服务热线",
        prop: "serviceHotline",
        // search: true,
        rules: [
          {
            required: true,
            message: "请输入热线号码",
            trigger: "blur",
          },
        ],
      },
    ],
  };
};
